export default {
  text: 'Receive exclusive discounts and news from us by email',
};
